import { buttonStylesReset } from '../../../jss';

export const animatedClasses = {
    enter: 'postfilters-animate_enter',
    enterActive: 'postfilters-animate_enter-active',
    leave: 'postfilters-animate_leave',
    leaveActive: 'postfilters-animate_leave-active'
};

export const styles = {
    container: {
        position: 'relative'
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: 30,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        animation: 'overlay 0.2s linear'
    },
    content: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        minHeight: '100%',
        zIndex: 30,
        backgroundColor: '#fff'
    },
    fullWidth: {
        width: '100%'
    },
    header: {
        height: 56,
        fontSize: 14,
        borderBottom: '2px solid #E3E3E3'
    },
    closeButton: {
        ...buttonStylesReset,
        float: 'left',
        padding: [21, 20, 15, 20],
        width: 60,
        height: 56,
        cursor: 'pointer'
    },
    title: {
        display: 'block',
        margin: 0,
        float: 'left',
        lineHeight: '56px',
        fontSize: 16,
        fontWeight: 'bold',
    },
    children: {
        height: 'calc(100% - 60px)',
        overflowY: 'scroll'
    },

    [`.${animatedClasses.enter}`]: {
        transform: 'translateX(-100%)'
    },

    [`.${animatedClasses.leave}`]: {
        transform: 'translateX(0)'
    },

    [`.${animatedClasses.enterActive}`]: {
        transform: 'translateX(0)',
        transition: 'transform 300ms linear'
    },

    [`.${animatedClasses.leaveActive}`]: {
        transform: 'translateX(-100%)',
        transition: 'transform 300ms linear'
    },

    '@keyframes overlay': {
        '0%': {
            backgroundColor: 'rgba(0, 0, 0, 0.0)'
        },
        '50%': {
            backgroundColor: 'rgba(0, 0, 0, 0.3)'
        },
        '100%': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
